export default "__VITE_ASSET__55820fa1__"